// extracted by mini-css-extract-plugin
export var profile = "profile-module--profile--631d4";
export var profile__container = "profile-module--profile__container--56294";